export class ApiRequestError extends Error {
  constructor(message: string, readonly status: number, readonly traceId?: string) {
    super(message);
    this.name = 'ApiRequestError';
  }
}
